import { createRouter, createWebHashHistory } from 'vue-router'

;(function cleanTelegramHash() {
  const hash = window.location.hash
  if (hash && hash.includes('tgWebApp')) {
    console.log('[Router] Cleaning Telegram hash params:', hash.slice(0, 80) + '...')
    window.location.hash = '#/'
  }
})()

const routes = [
  { path: '/', name: 'preloader', component: () => import('@/pages/NewPreloaderPage.vue'), meta: { layout: 'preloader' } },
  { path: '/airdrop', name: 'airdrop', component: () => import('@/pages/AirdropPage.vue'), meta: { layout: 'standard' } },
  { path: '/roadmap', name: 'roadmap', component: () => import('@/pages/RoadmapPage.vue'), meta: { layout: 'standard' } },
  { path: '/rules', name: 'rules', component: () => import('@/pages/RulesPage.vue'), meta: { layout: 'standard' } },
  { path: '/profile', name: 'profile', component: () => import('@/pages/ProfilePage.vue'), meta: { layout: 'standard' } },
  { path: '/:pathMatch(.*)*', redirect: '/airdrop' },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  routes,
})

export default router
